module.exports = __webpack_public_path__ + "img/order_pending_tray.ae82421c.png";